import React from "react";
import {  FILTER_DOCUMENT_PATH, FILTER_BY, ATTRIBUTES, BRX_API_HOST } from "./APIUtils";
import { LabelContext } from "./label.context";
import { Item } from "../components/configurator";

export const GeneralContext = React.createContext<any>(null!);

export const GeneralContextComponent = (props: any) => {

    const { t } = React.useContext(LabelContext);

    /* === DATI === */

    // New version
    const [colors, setColors] = React.useState<any[]>([]);
    const [families, setFamilies] = React.useState([]);
    const [models, setModels] = React.useState<any[]>([]);
    const [start, setStart] = React.useState(0);
    const [loading, setLoading] = React.useState(1);

    //FAB

    const [types, setType] = React.useState<any[]>([]);
    const [productsfab, setProductsfab] = React.useState<any[]>([]);
    const [selectedType, setSelectedType] = React.useState<any>(null!);
    const typeMapping: { [key: string]: any[] } = {};
    const [typesMapping, settypesMapping] = React.useState<any>(null!);
    const famMapping: { [key: string]: any[] } = {};
    
    
    const [show, setShow] = React.useState(false);	

    const [step, setStep] = React.useState(0);
	const [prevStep, setPrevStep] = React.useState(0);

	const [items, setItems] = React.useState<any>([]);
	const [selectedProduct, setSelectedProduct] = React.useState<any>();

	const [checkChange, setCheckChange] = React.useState<number>(0);
	const [titleStep, setTitleStep] = React.useState<number>(0);

    const setPreviousState = (step:any) => {
        if (step == 3) {
            setStep(2)
            setItems(null) 
            setSelectedProduct(null)
            setItems(selectedType.filter((item:any) => item.position !== '2'))
        }
        if (step == 2) {
            setStep(0)
            setItems(null)
            setSelectedProduct(null)
            setItems(families)
        }
    }

    const handleTypeClick = (type: any) => {
        setItems(typesMapping[type].filter((item:any) => item.position !== '2'))
        setSelectedType(typesMapping[type])
        setStep(2)
        
      };

      const findItemsWithDifferentLetter = (selectedType:any, targetItem:any) => {
        const differentLetterItems = selectedType.filter((item:any) => {
       
          if (item.item.sku.length !== targetItem.length) {
            return false; 
          }
      
          let diffCount = 0;
      
          for (let i = 0; i < item.item.sku.length; i++) {
            
            if (item.item.sku[i] !== targetItem[i]) {
                diffCount++;
                    if (diffCount > 1) {
                    return false; 
                    } 
                }
              
           else if (((item.item.sku[i] === "R" || item.item.sku[i] === "L") && (targetItem[i] === "R" || targetItem[i] === "L"))) {
                diffCount =1
                if (item.item.sku[i] !== targetItem[i]) {
                diffCount++;
                    if (diffCount > 1) {
                    return false; 
                    } 
                }
            }
           
          }
      
          return diffCount === 1;
        });
      
      
        return differentLetterItems;
      };
      
      
      const handleItemClick = (selectedType:any, item:any) => {
        
        const differentLetterItems = findItemsWithDifferentLetter(selectedType, item);
        setStep(3);
        if (differentLetterItems.length === 2) {
            setItems(differentLetterItems)
            
        } else {
            setSelectedProduct(item)
            
        }
      };
    
    /** 
        Richiama Prodotti e Filtri
        Rielabora i prodotti per semplificare la lettura successiva dei dati
        Estrae i modelli
    **/
    const init = () => {
        
        const requestOptionsForProduct = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
                {
                    query_filter: FILTER_BY,
                    query_terms_values: ATTRIBUTES
                }
            )
        }

        const requestOptionsForFilter = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
                {
                    "filter_documents_path": FILTER_DOCUMENT_PATH
                }
            )
        }

        let _colors: any;

        fetch(BRX_API_HOST + "/v1/beans/retrieve_filters", requestOptionsForFilter)
            .then(res => res.json())
            .then((result) => {
                if (result.code === 200) {
                    const attributes = JSON.parse(result.attributes);
                    _colors = JSON.parse(result.colors);
                    setColors(_colors)

                    let _attributes = attributes.map(
                        (attribute: any) => {
                            return { ...attribute, "activeImage": attribute.activeImage?.replace('/brx%3AdoubleDeskLarge', '') };
                        }
                    );

                    setFamilies(_attributes)

                } else {
                    console.log(result.message)
                }
            },
                (error) => {
                    console.log(error);
                })
            .then(
                () => fetch(BRX_API_HOST + "/v1/beans/products", requestOptionsForProduct)
                    .then(res => res.json())
                    .then((result) => {
                        if (result.code === 200) {
                            const realProducts = JSON.parse(result.products)
                            
                            const filterAllFAB = Object.values(realProducts).filter((el: any) => el.sku?.startsWith('FAB'))
                            const filterFAB = Object.values(filterAllFAB).filter((el: any) => !el.sku?.includes('-DG_'))
                            const filterFABall:any[] = []
                            let filterSize: any[] = []
                            filterFAB.forEach((el: any) => {
                                let type: string = el.sku.slice(0, 3)
                                let size: any = el.sku.slice(3).slice(0, 2)
                                let fam: any = type + size
                                let basicInfo = JSON.parse(el.basicInfo)
                                let position: string = basicInfo?.HINGE_POS?.value ? basicInfo?.HINGE_POS?.value : "missing"
                                let color: string = basicInfo?.NEW_COLOR?.txt ? basicInfo?.NEW_COLOR?.value : " missing"
                                
                                if ([...size].some(isNaN)) {
                                    size = size.slice(0, 1)
                                    fam = type + size
                                }
                                
                                const item = {
                                    type: type,
                                    size: size,
                                    fam: fam,
                                    position: position,
                                    ccolor: color,
                                    item: el
                                }
                                if (famMapping[fam]) {
                                    famMapping[fam].push(item);
                                } else {
                                    famMapping[fam] = [item];
                                }
                                if (!filterSize.find(x => x.sku == size)) {
                                    filterSize.push(item)
                                }
                                filterFABall.push(item)
                            })
                            const types = Object.keys(typeMapping);
                            
                            settypesMapping(famMapping)
                            setType(types)  
                            setProductsfab(filterFABall); 
                            
                            filterSize.sort((a, b) => a.sku - b.sku);
                            
                            setModels(filterSize);
                            

                        } else {
                            console.log(result.message)
                        }
                    },
                        (error) => {
                            console.log(error);
                        })
                    .then(() => setLoading(0))
            )
    }
    
    React.useEffect(() => {
        init();
    }, [show, checkChange]);

    return (
        <GeneralContext.Provider value={{
            types,
            productsfab,
            colors,
            families,
            loading,
            models,
            start,
            setStart,
            typeMapping,
            handleTypeClick, 
            selectedType,
            typesMapping,
	    	step: step,
	    	setStep: setStep,
	    	items:items,
	    	selectedProduct: selectedProduct,
	    	setShow: setShow,
	    	show:show,
	    	setPrevStep: setPrevStep,
	    	prevStep: prevStep,
	    	setPreviousState: setPreviousState,
	    	setSelectedProduct: setSelectedProduct,
	    	setCheckChange:setCheckChange,
	    	checkChange:checkChange,
	    	titleStep: titleStep,
            setItems,
            handleItemClick
        }}>
            {props.children}
        </GeneralContext.Provider>
    );
};
